import Vue from 'vue'

const state = new Vue({
  data() {
    return {
      state: {
        app: {
          apiUrl: this.compApiUrl
        },
        sites: [],
        filterString: ''
      }
    }
  },
  mounted() {
  },
  computed: {
    compApiUrl() {
      let port = ''
      if (window.location.hostname === 'localhost') {
        port = ':3000'
      }
      return window.location.protocol + '//' + window.location.hostname + port + '/v1/'
    },
    compFilteredSiteList() {
      let res
      if (this.state.filterString) {
        res = this.state.sites.filter((i) => i.url.includes(this.state.filterString))
      } else {
        res = this.state.sites
      }
      res = res.sort((a,b) => (a.url > b.url) ? 1 : ((b.url > a.url) ? -1 : 0))
      return res
    }
  },
  methods: {
    async getSites() {
      let result
      console.log(this.compApiUrl)
      try {
        result = await this.$http.get(this.compApiUrl + 'getSites')
      } catch(err) {
        console.log(err)
      }
      this.state.sites = Object.assign([], result.data)
    },
    async addSite(site) {
      let result
      try {
        result = await this.$http.get(this.compApiUrl + 'addSite', { 
          params: {
            url: site.url,
            checkSSL: true,
            checkUp: true
          }
        })
        this.state.sites.unshift(result.data)
        return true
      } catch(err) {
        console.log(err)
      }
    },
    async delSite(site) {
      let result
      try {
        result = await this.$http.get(this.compApiUrl + 'delSite', { 
          params: {
            id: site.id
          }
        })
        if (result) {
          this.state.sites = this.state.sites.filter((i) => site.id !== i.id)
        }
        return true
      } catch(err) {
        console.log(err)
      }
    },
    async refreshSSL(site) {
      let result
      try {
        result = await this.$http.get(this.compApiUrl + 'checkSingleSSL', { 
          params: {
            id: site.id
          }
        })
        let siteIndex = this.state.sites.findIndex((i) => i.id == site.id)
        this.state.sites[siteIndex] = Object.assign({}, result.data)
        this.state.sites = Object.assign([], this.state.sites)
      } catch(err) {
        console.log(err)
      }
    }
  }
})

export const store = state